var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: _vm.$style.container
  }, [!_vm.loading ? _vm._t("default") : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    class: _vm.$style.loader
  }, _vm._l(_vm.rows, function (row, idx) {
    return _c('div', {
      key: idx,
      class: _vm.$style.row,
      style: _vm.getAnimationDelayVariables()
    }, [_c('div', {
      class: _vm.$style.skeleton
    })]);
  }), 0)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }